import React from 'react';
import AriaModal from './IGTIcons/aria-modal';
import Forms from './IGTIcons/forms';
import Headings from './IGTIcons/headings';
import Images from './IGTIcons/images';
import InteractiveElements from './IGTIcons/interactive-elements';
import Keyboard from './IGTIcons/keyboard';
import Lists from './IGTIcons/lists';
import PageInfo from './IGTIcons/page-info';
import Structure from './IGTIcons/structure';
import Table from './IGTIcons/table';
import IgtDeprecated from './IGTIcons/igt-deprecated';

const Icons = {
  AriaModal,
  Forms,
  Headings,
  Images,
  InteractiveElements,
  Keyboard,
  Lists,
  PageInfo,
  Structure,
  Table,
  IgtDeprecated
};

export type IconKey = keyof typeof Icons;

const IGTIcon = ({
  type,
  ...props
}: { type: string } & React.SVGProps<SVGSVGElement>): JSX.Element => {
  const componentName = type
    .split('-')
    .map(word => word[0].toUpperCase() + word.slice(1))
    .join('') as IconKey;
  const Component = Icons[componentName] || React.Fragment;
  return <Component {...props} />;
};

export default IGTIcon;
